import { useEffect, useState } from 'react';
import { useUnit } from 'effector-react';
import { $recipientListStore, $recipientRecentStore } from '@lib/store';
import { type RecipientResponse, TransferRecipientTypeEnum } from '@shared/api/rest/recipients';
import { Spinner, Tabs, Text } from '@shared/widgets';
import { SelectRecipient } from '@shared/widgets/select';
import { RecentRecipientIcon } from './recentRecipientIcon';
import { RecipientDetails } from './recipientDetails';

interface RecipientSelectBlockProps {
  allTabs?: { label: string; value: TransferRecipientTypeEnum }[];
  currentTab?: TransferRecipientTypeEnum;
  onChangeTab?: (x: TransferRecipientTypeEnum) => void;
  recipient: RecipientResponse | null;
  setRecipient: (val: RecipientResponse | null) => void;
  toggleRecipientDetails: () => void;
  isShowRecipientDetails: boolean;
  type: TransferRecipientTypeEnum;
  isInternalAccount?: boolean;
}

export const RecipientSelectBlock = (props: RecipientSelectBlockProps) => {
  const recipientListStore = useUnit($recipientListStore.store);
  const recipientRecentStore = useUnit($recipientRecentStore.store);

  const [searchValue, setSearchValue] = useState<string>('');

  useEffect(() => {
    $recipientRecentStore.events.update({ Type: props.type, isInternalAccount: !!props.isInternalAccount });
  }, [props.isInternalAccount, props.type]);

  useEffect(() => {
    $recipientListStore.events.update({
      Count: 100,
      ReturnTotalCount: true,
      SearchQuery: searchValue,
      Type: props.type,
      isInternalAccount: !!props.isInternalAccount,
    });
  }, [searchValue, props.isInternalAccount, props.type]);

  return (
    <>
      {props.allTabs && props.onChangeTab && props.currentTab && (
        <Tabs options={props.allTabs} value={props.currentTab} onChange={props.onChangeTab} />
      )}
      <div className='mt-6'>
        <SelectRecipient
          label='Transfer to'
          items={recipientListStore.data?.data.filter((r) => r.type === props.type)}
          value={props.recipient}
          onChange={props.setRecipient}
          searchValue={searchValue}
          onSearch={setSearchValue}
        />
      </div>
      {recipientRecentStore.loading ? (
        <Spinner />
      ) : (
        recipientRecentStore.data.some((r) => r.type === props.type) && (
          <div className='flex flex-col'>
            <Text className='my-3'>Recent recipients</Text>
            <div className='flex flex-row overflow-x-auto'>
              {recipientRecentStore.data
                .filter((r) => r.type === props.type)
                .map((x, key) => (
                  <div
                    key={key}
                    className='flex dark:bg-eerie-black bg-ice py-3 px-2 mr-2 cursor-pointer rounded-sm'
                    onClick={() => props.setRecipient(x)}
                  >
                    <RecentRecipientIcon
                      firstName={x.firstName}
                      lastName={x.lastName}
                      companyName={x.companyName}
                      accountNumber={x.accountNumber}
                      iban={x.iban}
                    />
                  </div>
                ))}
            </div>
          </div>
        )
      )}
      {props.recipient && (
        <RecipientDetails
          recipient={props.recipient}
          toggleDetails={props.toggleRecipientDetails}
          isShowRecipientDetails={props.isShowRecipientDetails}
        />
      )}
    </>
  );
};
